import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkDeleteTasks } from 'services/contentPlannerService';
import {
  error as renderError,
  success as renderSuccess,
} from 'helpers/toaster';
import keys, { BriefsKey } from 'constants/queryKeys';

const useBulkDeleteTasks = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkDeleteTasks,
    retry: false, // Don't retry on failure
    onSuccess: (response) => {
      const { data } = response;

      // Handle different response scenarios
      if (data.deleted_count > 0) {
        // Show success message
        renderSuccess(data.message);

        // If there are failed deletions, show them as additional info
        if (data.failed_ids && data.failed_ids.length > 0) {
          // Show details about failed deletions
          data.failed_ids.forEach(({ id, error }) => {
            renderError(`Task ${id}: ${error}`);
          });
        }

        // Invalidate and refetch briefs data
        try {
          // Invalidate all briefs queries to ensure fresh data
          queryClient.invalidateQueries({
            queryKey: [BriefsKey],
            exact: false,
          });
          queryClient.invalidateQueries({
            queryKey: keys.RecentBriefs,
            exact: false,
          });

          // Force refetch the current queries
          queryClient.refetchQueries({
            queryKey: [BriefsKey],
            exact: false,
          });
          queryClient.refetchQueries({
            queryKey: keys.RecentBriefs,
            exact: false,
          });
        } catch (error) {
          // Silently handle query invalidation errors
        }
      }
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.error || 'Failed to delete tasks';
      renderError(errorMessage);
    },
  });
};

export default useBulkDeleteTasks;
